import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import config from '../utils/config';
import { Device } from '../types';

export function useDevices() {
  const [devices, setDevices] = useState<Device[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const response = await axiosInstance.get<Device[]>(`${config.devicesApiUrl}/devices`);
        const sortedDevices = [...response.data].sort((a, b) => a.id - b.id);
        setDevices(sortedDevices);
      } catch (err) {
        console.error('Error fetching devices:', err);
        setError('Failed to fetch devices');
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, []);

  return { devices, loading, error, setDevices };
}
